<script lang="ts" setup>
const authStore = useAuthStore()
const currentUser = computed(() => authStore.currentUser)

const greeting = computed(() => {
    const hour = new Date().getHours()
    if (hour < 12) return 'Guten Morgen'
    if (hour < 18) return 'Guten Tag'
    return 'Guten Abend'
})
</script>

<template>
    <v-container fluid class="pa-0">
        <!-- Hero Section -->
        <v-card class="mb-6" color="primary" variant="flat">
            <v-card-text class="pa-6">
                <div class="d-flex align-center mb-2">
                    <v-icon size="32" class="mr-3">mdi-view-dashboard</v-icon>
                    <h1 class="text-h4 font-weight-bold">{{ greeting }}</h1>
                </div>
                <p class="text-h6 font-weight-regular opacity-90 mb-0">
                    Hier ist eine Übersicht über deine HortPlus-Einstellungen
                </p>
            </v-card-text>
        </v-card>

        <!-- Status Cards -->
        <v-row dense>
            <v-col cols="12" md="6">
                <push-status-card />
            </v-col>
            <v-col cols="12" md="6">
                <hort-pro-status-card />
            </v-col>
        </v-row>

        <!-- Quick Info Card -->
        <v-card class="mt-6" variant="tonal">
            <v-card-text class="pa-4">
                <div class="d-flex align-center">
                    <v-icon size="24" class="mr-3" color="primary">mdi-information-outline</v-icon>
                    <div>
                        <div class="text-body-2 font-weight-medium">Weitere Einstellungen</div>
                        <div class="text-caption text-medium-emphasis">
                            Klicke auf eine Karte oder besuche die Einstellungsseite für detaillierte Konfigurationen
                        </div>
                    </div>
                </div>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<style scoped>
</style>
